import ApexLogo from './apex-logo.png';
import React, { Component } from "react";
import axios from "axios";
import { Navigate } from 'react-router-dom';

export class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loginStatus: 0,
            redirect: false,
            isLoading: false,
            network: false
        };
        this.usernameRef = React.createRef();
        this.passwordRef = React.createRef();
    }

    authenticate = event => {
        event.preventDefault(); // Prevent form submission
        const username = this.usernameRef.current.value;
        const password = this.passwordRef.current.value;
        const userObj = { username, password };

        if (username && password) {
            this.setState({ isLoading: true, loginStatus: 0 });
            
            axios.post(`auth/token`, userObj)
                .then(response => {
                    if(response.code === 'ERR_NETWORK')
                    {
                        this.setState({ loginStatus: 3, isLoading: false });
                    }
                    else
                    {
                        if(response.status === 200) {
                            this.setState({ loginStatus: 1, redirect: true, isLoading: false });
                            localStorage.setItem('token', response.data.access_token);
                            
                            // Store firstname from response
                            if (response.data.firstname) {
                                localStorage.setItem('userName', response.data.firstname);
                            }
                            
                            // Decode JWT token to get user ID
                            try {
                                const token = response.data.access_token;
                                const tokenPayload = JSON.parse(atob(token.split('.')[1]));
                                if (tokenPayload.id) {
                                    localStorage.setItem('user_id', tokenPayload.id);
                                }
                            } catch (e) {
                                console.error('Error decoding token:', e);
                            }
                        }
                        else if(response.response.status === 401)
                        {
                            this.setState({ loginStatus: 2, isLoading: false });
                        }
                        else
                        {
                            console.log(response);
                            this.setState({ network: true, isLoading: false });
                        }
                    }
                })
                .catch(error => {
                    this.setState({ loginStatus: 3, isLoading: false });
                });
        }
    };

    render() {
        const { loginStatus, redirect, isLoading, network } = this.state;
        let authStatus;

        if(network){
            authStatus = (
                <div className="alert alert-danger" role="alert" style={{ marginBottom: '20px', borderRadius: '8px' }}>
                    Something went wrong, please try again.
                </div>
            );
        }

        if (loginStatus === 1) {
            authStatus = (
                <div className="alert alert-success" role="alert" style={{ marginBottom: '20px', borderRadius: '8px' }}>
                    Authentication successful! Redirecting...
                </div>
            );
        } else if (loginStatus === 2) {
            authStatus = (
                <div className="alert alert-danger" role="alert" style={{ marginBottom: '20px', borderRadius: '8px' }}>
                    Incorrect email or password. Please try again.
                </div>
            );
        } else if (loginStatus === 3) {
            authStatus = (
                <div className="alert alert-danger" role="alert" style={{ marginBottom: '20px', borderRadius: '8px' }}>
                    Network Error. Please try again.
                </div>
            );
        }

        if (redirect) {
            return <Navigate to="/home" />;
        } else {
            return (
                <div style={{ 
                    minHeight: '100vh', 
                    background: 'linear-gradient(135deg, #0069d9 0%, #004ba2 100%)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '20px'
                }}>
                    <div style={{
                        background: 'white',
                        borderRadius: '20px',
                        boxShadow: '0 20px 60px rgba(0, 0, 0, 0.1)',
                        padding: '60px 50px',
                        width: '100%',
                        maxWidth: '450px',
                        textAlign: 'center'
                    }}>
                        {/* Logo */}
                        <div style={{ marginBottom: '40px' }}>
                            <img 
                                src={ApexLogo} 
                                alt="APEX" 
                                style={{ 
                                    width: '120px', 
                                    height: 'auto',
                                    marginBottom: '20px'
                                }} 
                            />
                            <p style={{ 
                                color: '#6b7280', 
                                fontSize: '16px',
                                margin: '0'
                            }}>
                                Sign in to your account
                            </p>
                        </div>

                        {/* Auth Status */}
                        {authStatus}

                        {/* Login Form */}
                        <form onSubmit={this.authenticate} style={{ textAlign: 'left' }}>
                            <div style={{ marginBottom: '25px' }}>
                                <label 
                                    htmlFor="username" 
                                    style={{ 
                                        display: 'block',
                                        fontWeight: '500', 
                                        marginBottom: '8px',
                                        color: '#374151',
                                        fontSize: '14px'
                                    }}
                                >
                                    Email Address
                                </label>
                                <input
                                    type="email"
                                    name="username"
                                    ref={this.usernameRef}
                                    id="username"
                                    className="form-control"
                                    disabled={isLoading}
                                    placeholder="Enter your email"
                                    style={{
                                        height: '50px',
                                        borderRadius: '12px',
                                        border: '1px solid #d1d5db',
                                        fontSize: '16px',
                                        padding: '0 16px',
                                        transition: 'all 0.2s ease',
                                        backgroundColor: isLoading ? '#f9fafb' : 'white'
                                    }}
                                    onFocus={(e) => {
                                        e.target.style.borderColor = '#0069d9';
                                        e.target.style.boxShadow = '0 0 0 3px rgba(0, 105, 217, 0.1)';
                                    }}
                                    onBlur={(e) => {
                                        e.target.style.borderColor = '#d1d5db';
                                        e.target.style.boxShadow = 'none';
                                    }}
                                />
                            </div>
                            
                            <div style={{ marginBottom: '30px' }}>
                                <label 
                                    htmlFor="password" 
                                    style={{ 
                                        display: 'block',
                                        fontWeight: '500', 
                                        marginBottom: '8px',
                                        color: '#374151',
                                        fontSize: '14px'
                                    }}
                                >
                                    Password
                                </label>
                                <input
                                    type="password"
                                    name="password"
                                    ref={this.passwordRef}
                                    id="password"
                                    className="form-control"
                                    disabled={isLoading}
                                    placeholder="Enter your password"
                                    style={{
                                        height: '50px',
                                        borderRadius: '12px',
                                        border: '1px solid #d1d5db',
                                        fontSize: '16px',
                                        padding: '0 16px',
                                        transition: 'all 0.2s ease',
                                        backgroundColor: isLoading ? '#f9fafb' : 'white'
                                    }}
                                    onFocus={(e) => {
                                        e.target.style.borderColor = '#0069d9';
                                        e.target.style.boxShadow = '0 0 0 3px rgba(0, 105, 217, 0.1)';
                                    }}
                                    onBlur={(e) => {
                                        e.target.style.borderColor = '#d1d5db';
                                        e.target.style.boxShadow = 'none';
                                    }}
                                />
                            </div>

                            <button 
                                type="submit" 
                                disabled={isLoading}
                                style={{ 
                                    width: '100%',
                                    height: '50px',
                                    background: isLoading ? '#9ca3af' : 'linear-gradient(135deg, #0069d9 0%, #004ba2 100%)',
                                    border: 'none',
                                    borderRadius: '12px',
                                    color: 'white',
                                    fontSize: '16px',
                                    fontWeight: '600',
                                    cursor: isLoading ? 'not-allowed' : 'pointer',
                                    transition: 'all 0.2s ease',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: '10px',
                                    marginBottom: '25px'
                                }}
                                onMouseEnter={(e) => {
                                    if (!isLoading) {
                                        e.target.style.transform = 'translateY(-1px)';
                                        e.target.style.boxShadow = '0 10px 25px rgba(0, 105, 217, 0.3)';
                                    }
                                }}
                                onMouseLeave={(e) => {
                                    if (!isLoading) {
                                        e.target.style.transform = 'translateY(0)';
                                        e.target.style.boxShadow = 'none';
                                    }
                                }}
                            >
                                {isLoading ? (
                                    <>
                                        <div style={{
                                            width: '20px',
                                            height: '20px',
                                            border: '2px solid rgba(255, 255, 255, 0.3)',
                                            borderTop: '2px solid white',
                                            borderRadius: '50%',
                                            animation: 'spin 1s linear infinite'
                                        }}></div>
                                        Signing in...
                                    </>
                                ) : (
                                    'Sign In'
                                )}
                            </button>

                            <div style={{ textAlign: 'center' }}>
                                <a 
                                    href="/forgot-password" 
                                    style={{ 
                                        color: '#0069d9', 
                                        textDecoration: 'none',
                                        fontSize: '14px',
                                        fontWeight: '500'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.target.style.textDecoration = 'underline';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.textDecoration = 'none';
                                    }}
                                >
                                    Forgot your password?
                                </a>
                            </div>
                        </form>
                    </div>

                    {/* CSS Animation */}
                    <style jsx>{`
                        @keyframes spin {
                            0% { transform: rotate(0deg); }
                            100% { transform: rotate(360deg); }
                        }
                    `}</style>
                </div>
            );
        }
    }
}

export default Login;